import React, { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { useDataProvider } from 'src/app/common/utils';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import BulkUploadFailedList from './components/BulkUploadFailedList';
import { BULK_UPLOAD_TYPE, BulkUploadFailedItem } from 'src/app/modules/pruwallet/types/bulk-upload-types';
import {
  fetchBulkUploadAwardFailedList,
  fetchBulkUploadCreditFailedList,
} from 'src/app/modules/pruwallet/network/bulkUploadCrud';

type BulkUploadFailedListingPageProps = {} & ParamsProps;

const BulkUploadFailedListingPage: FC<BulkUploadFailedListingPageProps> = ({ initialParams, onChangeQueryParams }) => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get('type');
  const [bulkUploadFailedList, setBulkUploadFailedList] = useState<BulkUploadFailedItem[]>([]);

  const { isLoading, refreshData } = useDataProvider(
    // @ts-ignore
    async () => {
      if (id) {
        try {
          switch (type) {
            case BULK_UPLOAD_TYPE.CREDIT:
              return await fetchBulkUploadCreditFailedList(id, dispatch);
            default:
              return await fetchBulkUploadAwardFailedList(id, dispatch);
          }
        } catch (err) {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        }
      }
    },
    setBulkUploadFailedList,
    false,
  );

  return (
    <>
      <BulkUploadFailedList isLoading={isLoading} bulkUploadFailedList={bulkUploadFailedList} />
    </>
  );
};

export default BulkUploadFailedListingPage;
